<template>
	<router-view/>
</template>

<script>
export default {
	name: "Author.vue"
}
</script>

<style scoped>

</style>
